/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import {
	FormControl,
	Button,
	IconButton,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';

import { DivFormTitle } from './styles';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';

const MaintenanceFilterModal = (props) => {
	const dispatch = useDispatch();

	const page = 1;
	const limit = 30;
	const orderBy = "name";
	const order = "asc";

	const [createdAt, setCreatedAt] = useState(null);
	const [sendToMaintenanceDate, setSendToMaintenanceDate] = useState(null);
	const [returnFromMaintenanceDate, setReturnFromMaintenanceDate] = useState(null);
	const [warranty, setWarranty] = useState(null);
	const [expiration, setExpiration] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const [searchTextSite, setSearchTextSite] = useState('');
	const [sitesFormated, setSitesFormated] = useState([]);
	const [selectedSites, setSelectedSites] = useState([]);

	const [searchTextEquipment, setSearchTextEquipment] = useState('');
	const [equipmentsFormated, setEquipmentsFormated] = useState([]);
	const [selectedEquipments, setSelectedEquipments] = useState([]);

	const [searchTextPlace, setSearchTextPlace] = useState('');
	const [placesFormated, setPlacesFormated] = useState([]);
	const [selectedPlaces, setSelectedPlaces] = useState([]);

	const [searchTextStatusMaintenances, setSearchTextStatusMaintenances] = useState('');
  const [selectedStatusMaintenances, setSelectedStatusMaintenances] = useState([]);

	const statusMaintenances = [{
		value: 'scheduled',
		label: i18n.t('maintenancesStatusLabel.title3')
	},
  {
		value: 'pending',
		label: i18n.t('maintenancesStatusLabel.title4')
	},
  {
		value: 'progress',
		label: i18n.t('maintenancesStatusLabel.title')
	},
  {
		value: 'expired',
		label: i18n.t('maintenancesStatusLabel.title6')
	},
  {
		value: 'completed',
		label: i18n.t('maintenancesStatusLabel.title2')
	},
  {
		value: 'overdue',
		label: i18n.t('maintenancesStatusLabel.title5')
	},
	{
		value: 'canceled',
		label: i18n.t('maintenancesStatusLabel.title1')
	}];

	const fetchSites = useCallback(
		() => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
		[page, limit, searchTextSite, order, orderBy]
	);

	const fetchEquipments = useCallback(
		() => dispatch(actions.fetchEquipmentModels(page, limit, searchTextEquipment, order, orderBy)),
		[page, limit, searchTextEquipment, order, orderBy]
	);

	const fetchPlaces = useCallback(
		() => dispatch(actions.fetchPlacesLeafs(selectedSites)),
		[selectedSites]
	);
	const sites = useSelector(state => state.sites.sites);	
	const equipments = useSelector(state => state.equipmentModels.equipmentModels);
	const places = useSelector(state => state.places.placesLeafs);

	const filteredSites = useSelector(state => state.sites.selectedSitesPlaces);
	const filteredEquipments = useSelector(state => state.maintenances.filteredEquipments);
	const filteredPlaces = useSelector(state => state.maintenances.filteredPlaces);
	const filteredStatus = useSelector(state => state.maintenances.filteredStatus);
	const filteredCreatedAt = useSelector(state => state.maintenances.createdAt);
	const filteredSendToMaintenanceDate = useSelector(state => state.maintenances.sendToMaintenanceDate);
	const filteredReturnFromMaintenanceDate = useSelector(state => state.maintenances.returnFromMaintenanceDate);
	const filteredWarranty = useSelector(state => state.maintenances.warranty);
	const filteredExpiration = useSelector(state => state.maintenances.expiration);
	const filteredEndDate = useSelector(state => state.actions.endDate);

	const loadingSites = useSelector(state => state.sites.loading);
	const loadingEquipments = useSelector(state => state.equipmentModels.loading);
	const loadingPlaces = useSelector(state => state.places.loading);

	useEffect(() => {
		handleInputChangeSites(filteredSites);
		handleInputChangeEquipments(filteredEquipments);
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeStatusMaintenances(filteredStatus);
		setCreatedAt(filteredCreatedAt ? filteredCreatedAt : null);
		setSendToMaintenanceDate(filteredSendToMaintenanceDate ? filteredSendToMaintenanceDate : null);
		setReturnFromMaintenanceDate(filteredReturnFromMaintenanceDate ? filteredReturnFromMaintenanceDate : null);
		setWarranty(filteredWarranty ? filteredWarranty : null);
		setExpiration(filteredExpiration ? filteredExpiration : null);
		setEndDate(filteredEndDate ? filteredEndDate : null);
	}, []);

	useEffect(() => {
		fetchSites(limit, searchTextSite, order, orderBy);
	}, [searchTextSite]);	

	useEffect(() => {
		fetchEquipments(limit, searchTextEquipment, order, orderBy);
	}, [searchTextEquipment]);

	useEffect(() => {
		fetchPlaces(selectedSites);
	}, [selectedSites]);

	useEffect(() => {
		const dataFromRedux = sites
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
		setSitesFormated(returnArray)
	}, [sites])

	useEffect(() => {
		const dataFromRedux = equipments
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setEquipmentsFormated(returnArray)
	}, [equipments])

	useEffect(() => {
		const dataFromRedux = places
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.path }))
		setPlacesFormated(returnArray)
	}, [places])

	const handleInputChangeSelectorSites = (text) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorEquipments = (text) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangeSelectorPlaces = (text) => {
		setSearchTextPlace(text);
	}

	const handleInputChangeSelectorStatusMaintenances = (text) => {
		setSearchTextStatusMaintenances(text);
	}

	const handleInputChangeSites = selected => {
		if(selected) {
			const dataFromRedux = selected
			let returnArray = []
			dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
			setSelectedSites(returnArray);
		} else {
			setSelectedSites([]);
		}
	}

	const handleInputChangeEquipments = selected => {
		setSelectedEquipments(selected);
	}

	const handleInputChangePlaces = selected => {
		setSelectedPlaces(selected);
	}

	const handleInputChangeStatusMaintenances = selected => {
		setSelectedStatusMaintenances(selected);
	}

	const handleClickFilter = () => {
		dispatch(actions.setSitePlaces(selectedSites));
		dispatch(actions.filterMaintenanceEquipments(selectedEquipments));
		dispatch(actions.filterMaintenancePlaces(selectedPlaces));
		dispatch(actions.filterMaintenanceStatus(selectedStatusMaintenances));
		dispatch(actions.filterMaintenanceCreatedAt(createdAt));
		dispatch(actions.filterMaintenanceSendToMaintenanceDate(sendToMaintenanceDate));
		dispatch(actions.filterMaintenanceReturnFromMaintenanceDate(returnFromMaintenanceDate));
		dispatch(actions.filterMaintenanceWarranty(warranty));
		dispatch(actions.filterMaintenanceExpiration(expiration));
		dispatch(actions.filterActionEndDate(endDate));
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedEquipments([])
		setSelectedPlaces([])
		setSelectedStatusMaintenances([])
		setCreatedAt(null)
		setSendToMaintenanceDate(null)
		setReturnFromMaintenanceDate(null)
		setWarranty(null)
		setExpiration(null)
		setEndDate(null)
	}
	
	return (
        <div style={styles.container}>			
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					{i18n.t('filterListActionModalFilter.filter')}
					{((selectedEquipments && selectedEquipments.length > 0)
					|| (selectedPlaces && selectedPlaces.length > 0)
					|| (selectedStatusMaintenances && selectedStatusMaintenances.length > 0)
					|| (sendToMaintenanceDate)
					|| (createdAt)
					|| (returnFromMaintenanceDate)
					|| (warranty)
					|| (expiration))
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListActionModalFilter.clearFilter')}</div>}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites} //sent to isLoading
						label={i18n.t('autocompleteMaintenanceModalFilter.sites')}
						data={sitesFormated} // sent to options
						onSelectValue={handleInputChangeSites} // sent to onChange
						valueSelected={selectedSites} // sent to value
						newSearchText={handleInputChangeSelectorSites}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipments}
						label={i18n.t('autocompleteMaintenanceModalFilter.equipments')}
						data={equipmentsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipments}
						newSearchText={handleInputChangeSelectorEquipments}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('autocompleteMaintenanceModalFilter.place')}
						data={placesFormated}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={handleInputChangeSelectorPlaces}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						label={i18n.t('autocompleteMaintenanceModalFilter.status')}
						data={statusMaintenances}
						onSelectValue={handleInputChangeStatusMaintenances}
						valueSelected={selectedStatusMaintenances}
						newSearchText={handleInputChangeSelectorStatusMaintenances}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('autocompleteMaintenanceModalFilter.createdAt')}
						margin='normal'
						value={createdAt && new Date(createdAt)}
						onChange={date => setCreatedAt(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('autocompleteMaintenanceModalFilter.sendToMaintenanceDate')}
						margin='normal'
						value={sendToMaintenanceDate && new Date(sendToMaintenanceDate)}
						onChange={date => setSendToMaintenanceDate(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('autocompleteMaintenanceModalFilter.returnFromMaintenanceDate')}
						margin='normal'
						value={returnFromMaintenanceDate && new Date(returnFromMaintenanceDate)}
						onChange={date => setReturnFromMaintenanceDate(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('autocompleteMaintenanceModalFilter.warranty')}
						margin='normal'
						value={warranty && new Date(warranty)}
						onChange={date => setWarranty(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('autocompleteMaintenanceModalFilter.expiration')}
						margin='normal'
						value={expiration && new Date(expiration)}
						onChange={date => setExpiration(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
					{i18n.t('divActionModalFilter.buttonCancel')}
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
					{i18n.t('divActionModalFilter.button')}
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem', 
		marginLeft: '2rem', 
		color: '#fff', 
		cursor: 'pointer', 
		textDecoration: 'underline' 
	}
}


export default MaintenanceFilterModal;

